<template>
    <div class="not-found">
        <h1>404</h1>
        <p>Sayfa bulunamadı</p>
    </div>
</template>
<script>
export default {
    name: "NotFound",
};
</script>
<style lang="scss" scoped>
.not-found {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-size: 2rem;
    color: #2c3e50;
}
</style>
